import axios from 'axios';
import { FETCH_USER } from './types';

export const fetchUser = () => async (dispatch) => {
  const { data } = await axios.get('/auth/current_user').catch(() => false);
  dispatch({ type: FETCH_USER, payload: data });
};

export const handleSaveDocument = documentId => async (dispatch) => {
  const { data } = await axios.post('/users/documents', { documentId });
  dispatch({ type: FETCH_USER, payload: data });
};



// WEBPACK FOOTER //
// ./src/actions/index.js